import axiosClient from "./axiosClient";

// API quản lý Trang HTML (landing page dạng ladipage) — chỉ admin dùng được.
const landingPageApi = {
    getAll() {
        return axiosClient.get("page");
    },
    getOne(id) {
        return axiosClient.get(`page/${id}`);
    },
    create(payload) {
        return axiosClient.post("page", payload);
    },
    update(id, payload) {
        return axiosClient.put(`page/${id}`, payload);
    },
    toggle(id) {
        return axiosClient.patch(`page/${id}/toggle`);
    },
    delete(id) {
        return axiosClient.delete(`page/${id}`);
    },
    uploadImage(formData) {
        return axiosClient.post("page/upload-image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
};

export default landingPageApi;
